import React from 'react';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  className?: string;
}

/**
 * Select component
 * 
 * A styled select dropdown component
 */
const Select: React.FC<SelectProps> = ({ className = '', children, ...props }) => {
  return (
    <select
      className={`w-full px-3 py-2.5 text-base sm:py-2 sm:text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
        props.disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'
      } ${className}`}
      {...props}
    >
      {children}
    </select>
  );
};

export default Select; 